import { memo, useEffect, useState } from 'react';
import Table from '../../components/Table/Table';
import DateInput from '../../components/DateInput/DateInput';
import Filter from '../../components/Filter/Filter';
import {
  FirstFilterLine,
  SecondFilterLine,
} from '../../components/Filter/Filter.styles';
import TextInput from '../../components/TextInput/TextInput';
import Wrapper from '../../components/Wrapper/Wrapper';
import Button from '../../components/Button/Button';
import { useForm } from 'react-hook-form';
import { ImSearch } from 'react-icons/im';
import SelectOptions from '../../components/SelectOptions/SelectOptions';
import { theme } from '../../styles/theme';
import { useDispatch, useSelector } from 'react-redux';
import { transfersFetchAction } from '../../store/fetchActions/transfersActions';
import formatCPF from '../../utils/functions/formatCPF';
import { LoadingContainer } from '../GerenciarClientes/styles/GerenciarClientes.styles';
import { CircularProgress } from '@material-ui/core';
import StatusContainer from '../../components/StatusContainer/StatusContainer';
import ConvertObjToArrayTransferencias from './ConvertObjToArrayTransferencias';
import * as dayjs from 'dayjs';
import formatMoney from '../../utils/functions/formatMoneyBRL';
import Information from '../../components/Information/Information';
import Modal from '../../components/Modal/Modal';
import transformObjectUppercase from '../../utils/functions/transformObjectUppercase';
import useCallFilter from '../../utils/hooks/useCallFilter';

const { mainColor, mainColorButtonHover, rbmWhite } = theme.colors;

function Transferencias() {
  const dispatch = useDispatch();

  const [filterData, setFilterData] = useState('');
  const [isModalInfoOpen, setIsModalInfoOpen] = useState(false);
  const [ModalInfoData, setModalInfoData] = useState({});

  const [filter, setFilter] = useState({
    SEARCH: '',
    DATA_INICIAL: '',
    DATA_FINAL: '',
    AGENCIA: '',
    CONTA: '',
    TIPO: '',
    LIMIT: 10,
    PAGE: 1,
  });

  const {
    transfersData,
    paginationTransfers,
    loadingTransfers,
    errorTransfers,
    messageTransfers,
  } = useSelector((state) => state.transfers);

  useCallFilter(filterData, setFilter, transfersFetchAction, 0, 0);

  const filterTable = (data) => {
    setFilterData(data);
    dispatch(transfersFetchAction(transformObjectUppercase(data)));
  };

  const { handleSubmit, control } = useForm({});

  const pagesOptions = [
    { ID: 25, NOME: 25 },
    { ID: 50, NOME: 50 },
    { ID: 100, NOME: 100 },
  ];

  useEffect(() => {
    dispatch(transfersFetchAction(transformObjectUppercase(filter)));
  }, [filter.PAGE]);

  const dataBankSlipDetailArray =
    ConvertObjToArrayTransferencias(ModalInfoData);
  const arrayStatus = [
    { ID: '0', NOME: 'Todos' },
    { ID: 'Pix', NOME: 'Pix' },
    { ID: 'TED', NOME: 'TED' },
  ];

  const header = [
    {
      id: 'data e hora',
      name: 'DATA/HORA',
      align: 'center',
    },
    { id: 'cpf/cnpj', name: 'CPF/CNPJ', align: 'left' },
    { id: 'nome', name: 'NOME', align: 'left' },
    { id: 'tipo', name: 'TIPO', align: 'center' },
    { id: 'valor', name: 'VALOR', align: 'right' },
    { id: 'status', name: 'STATUS', align: 'center' },
  ];

  const body = transfersData?.map((transfer) => {
    return {
      data: [
        {
          info:
            dayjs(transfer.DATA_INSERT).format('DD/MM/YYYY HH:mm:ss') ||
            '-----',
          align: 'center',
        },
        {
          info: formatCPF(transfer.CPFCNPJ),
          align: 'left',
        },
        {
          info: transfer.NOME,
          align: 'left',
        },

        {
          info: transfer.TIPO,
          align: 'center',
        },

        {
          info: 'R$ ' + formatMoney(transfer.VALOR),
          align: 'right',
        },
        {
          info: transfer.STATUSTRANSACAO ? (
            <StatusContainer
              code={transfer.STATUSTRANSACAO}
              description={transfer.STATUS_DESCRICAO}
            ></StatusContainer>
          ) : (
            '-----'
          ),
          align: 'center',
        },
      ],
      onClick: () => inspectUser(transfer),
    };
  });

  const inspectUser = (data) => {
    setModalInfoData(data);
    setIsModalInfoOpen(true);
  };

  const closeModalInfo = () => setIsModalInfoOpen(false);
  return (
    <Wrapper title="Transferências">
      <div>
        <Filter>
          <form onSubmit={handleSubmit(filterTable)}>
            <FirstFilterLine>
              <TextInput
                label="Nome ou CPF/CNPJ"
                name={'SEARCH'}
                width={'36.042vw'}
                control={control}
                margin={'0 0 0 1.389vw'}
                inputProps={{ role: 'filter-text-input' }}
              />

              <SelectOptions
                label={'Tipo'}
                width={'5.528vw'}
                name={'TIPO'}
                control={control}
                options={arrayStatus}
                initialName={'Todos'}
                initialValue={'0'}
              />
              <DateInput
                label="Data Inicial"
                name={'DATA_INICIAL'}
                control={control}
              />
              <DateInput
                label="Data Final"
                name={'DATA_FINAL'}
                control={control}
              />

              <Button
                backgroundColor={'#303545'}
                width="12.153vw"
                margin={'0 1.389vw 0 0'}
                hoverBGColor={'#FF557E'}
                hoverColor={rbmWhite}
                color={'white'}
                type="submit"
                roleName="button-buscar-logs"
              >
                <ImSearch className="default-svg" size={'1.181vw'} />
                <span>Buscar</span>
              </Button>
            </FirstFilterLine>
            <SecondFilterLine>
              <h5>Resultados por página</h5>
              <SelectOptions
                control={control}
                options={pagesOptions}
                name={'LIMIT'}
                margin={'0 0 0 1.875vw'}
                initialValue={10}
                initialName={10}
              />
              <h5>Total de resultados: {paginationTransfers?.totalResult}</h5>
            </SecondFilterLine>
          </form>
        </Filter>
        {loadingTransfers ? (
          <LoadingContainer>
            <CircularProgress size={'5vw'} color="inherit" />
          </LoadingContainer>
        ) : (
          <Table
            loading={loadingTransfers}
            error={errorTransfers}
            hasPagination={true}
            filter={filter}
            pagination={paginationTransfers}
            setFilter={setFilter}
            errorMessage={messageTransfers}
            filterTable={filterTable}
            header={header}
            body={body}
            limit={filter.LIMIT}
          />
        )}
        <Modal
          open={isModalInfoOpen}
          close={closeModalInfo}
          title="Dados da Transferência"
          width={'45.889vw'}
        >
          <Information data={dataBankSlipDetailArray} />
        </Modal>
      </div>
    </Wrapper>
  );
}

export default memo(Transferencias);
